import { Col, Input, Row, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import DropdownSelect from "../../../components/generic/DropdownSelect";
import { QuestionCircleOutlined } from "@ant-design/icons";

const actionOptions = [
  { label: "Move", value: "Move" },
  { label: "Copy", value: "Copy" },
  { label: "Delete", value: "Delete" },
];
const { Option } = Select;
function FileMove(props) {
  const [fileName, setFileName] = useState("");
  const [matchDisabled, setMatchDisabled] = useState(false);
  const [matchType, setMatchType] = useState("");
  const [eventType, setEventType] = useState("");
  const eventMonitorObjects = {
    eventType,
    fileName,
    matchType,
    dbConnection: "",
    sql: "",
    environmentName: "",
  };
  useEffect(() => {
    props.saveFileMoveData(eventMonitorObjects);
  }, [eventType, fileName, matchType]);
  const onChangeActionTypeSelect = (value) => {
    setEventType(value);
  };
  return (
    <div>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Action *</p>
        </Col>
        <Col span={18}>
          <DropdownSelect
            placeholder="Select action type"
            options={actionOptions}
            labelKey="label"
            valueKey="value"
            onSelect={onChangeActionTypeSelect}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                setFileName("");
                setMatchDisabled(true);
              } else {
                setMatchDisabled(false);
              }
              setMatchType(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={fileName}
            disabled={matchDisabled}
            placeholder="file name"
            onChange={(e) => setFileName(e.target.value)}
            width="100%"
          />
        </Col>
      </Row>
    </div>
  );
}

export default FileMove;
